import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase/config';

const JoinRequestPopup = () => {
  const [modal, setModal] = useState(null);
  // modal = { eventId, requesterId, requesterName, requesterAvatar, requesterAge }

  useEffect(() => {
    const handleOpen = (e) => setModal(e.detail);
    window.addEventListener('openJoinRequestPopup', handleOpen);
    return () => window.removeEventListener('openJoinRequestPopup', handleOpen);
  }, []);

  if (!modal) return null;

  const { eventId, requesterId, requesterName, requesterAvatar, requesterAge } = modal;

  const fallbackAvatar = `https://ui-avatars.com/api/?name=${encodeURIComponent(requesterName || 'User')}&background=e8eaed&color=5f6368&size=80`;

  const handleAccept = () => {
    if (window.handleJoinRequest) window.handleJoinRequest(eventId, requesterId, 'accept');
    setModal(null);
  };

  const handleDecline = () => {
    if (window.handleJoinRequest) window.handleJoinRequest(eventId, requesterId, 'decline');
    setModal(null);
  };

  const handleCheckProfile = () => {
    if (window.showUserProfileFromRequest) window.showUserProfileFromRequest(requesterId, eventId);
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000,
        animation: 'fadeIn 0.2s ease-out'
      }}
    >
      <div
        style={{
          background: 'white',
          borderRadius: '16px',
          padding: '32px 24px',
          width: '90%',
          maxWidth: '400px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
          textAlign: 'center',
          animation: 'slideUp 0.3s ease-out'
        }}
      >
        {/* Avatar */}
        <img
          src={requesterAvatar || fallbackAvatar}
          onError={(e) => { e.target.src = fallbackAvatar; }}
          alt={requesterName}
          style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            objectFit: 'cover',
            border: '3px solid #4285f4',
            margin: '0 auto 16px',
            display: 'block'
          }}
        />

        {/* Title */}
        <h3 style={{ margin: '0 0 8px', fontSize: '18px', fontWeight: 600, color: '#202124' }}>
          {requesterName} would like to join your event
        </h3>

        {/* Age */}
        <p style={{ margin: '0 0 20px', fontSize: '14px', color: '#5f6368' }}>
          Age: {requesterAge}
        </p>

        {/* Check Profile */}
        <button
          onClick={handleCheckProfile}
          onMouseOver={(e) => e.currentTarget.style.background = '#f1f5f9'}
          onMouseOut={(e) => e.currentTarget.style.background = 'white'}
          style={{
            width: '100%',
            padding: '12px 20px',
            background: 'white',
            color: '#4285f4',
            border: '2px solid #4285f4',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: 600,
            cursor: 'pointer',
            marginBottom: '16px',
            transition: 'all 0.2s'
          }}
        >
          Check Profile
        </button>

        {/* Accept / Decline */}
        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            onClick={handleAccept}
            onMouseOver={(e) => e.currentTarget.style.background = '#2d8e47'}
            onMouseOut={(e) => e.currentTarget.style.background = '#34a853'}
            style={{
              flex: 1,
              padding: '12px 20px',
              background: '#34a853',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
          >
            Accept
          </button>
          <button
            onClick={handleDecline}
            onMouseOver={(e) => e.currentTarget.style.background = '#d33426'}
            onMouseOut={(e) => e.currentTarget.style.background = '#ea4335'}
            style={{
              flex: 1,
              padding: '12px 20px',
              background: '#ea4335',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
          >
            Decline
          </button>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
      `}</style>
    </div>
  );
};

export default JoinRequestPopup;